import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { BASIC_TELESTREAM_COLOR } from "@/utils/constants";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark:   true,
    themes: {
      dark: {
        background: "#3c3c3c",
        primary:    BASIC_TELESTREAM_COLOR,
        accent:     BASIC_TELESTREAM_COLOR
      }
    }
  }
});
